<template>
  <div id="customers-panel" class="panel panel-primary">
    <div class="panel-heading" style="text-align: left">
      Create New Subscription Addon
    </div>
    <form @submit.prevent="addSubscriptionBundleForm">
      <div class="panel-body">
        <div
          class="form-group"
          :class="codeExist ? 'has-error has-feedback' : ''"
        >
          <label class="control-label">Addon Code*</label>
          <input
            class="form-control"
            type="text"
            name="code"
            required
            @change="handleCode($event)"
          />
          <span
            v-if="codeExist"
            class="glyphicon glyphicon-remove form-control-feedback"
          ></span>
          <span v-if="codeExist" class="help-block">
            Please select a different Code.
          </span>
          <span class="help-block">Unique identifier for this addon</span>
        </div>

        <div class="form-group">
          <label class="control-label">Default Name*</label>
          <input
            v-model="name"
            class="form-control"
            type="text"
            name="name"
            value=""
            required
          />
        </div>

        <div class="form-group">
          <label class="control-label">Default Price*</label>
          <div class="input-group">
            <span class="input-group-addon">
              <span class="glyphicon glyphicon-usd"></span>
            </span>
            <input
              v-model="base_price"
              class="form-control"
              type="number"
              min="0"
              step="0.01"
              name="base_price"
              value=""
              required
            />
          </div>
        </div>

        <div class="form-group">
          <label class="control-label">Nexus Type*</label>
          <select
            v-model="nexus_type"
            class="form-control"
            name="nexus"
            required
            @change="handleNexusSelect($event)"
          >
            <option value="saas">SaaS Products</option>
            <option value="profs">Professional Services</option>
            <option value="hardware">Hardware & Boxed Software</option>
            <option value="digital">Digital Download</option>
          </select>
        </div>

        <div class="form-group">
          <label class="control-label">Default Description*</label>
          <input
            v-model="description"
            class="form-control"
            type="text"
            name="description"
            value=""
            required
          />
        </div>

        <div class="form-group">
          <label for="locale_id">Locale*</label>
          <select
            id="locale_id"
            v-model="locale_id"
            type="text"
            name="locale_id"
            class="form-control"
            required
            @change="handleLocaleSelect($event)"
          >
            <option
              v-for="locale in locales"
              :key="'locale_id_' + locale.id"
              :value="locale.id"
            >
              {{ locale.country }}
            </option>
          </select>
        </div>
        <hr />
        <div class="form-group">
          <label class="control-label">Eclipse Product Data</label>
          <div class="well">
            <div class="row">
              <div class="form-group col-xs-6" style="margin-bottom: 0">
                <label class="control-label">Product*</label>
              </div>

              <div
                v-for="(eclipseProduct, index) in eclipseProducts"
                :key="'eclipse_product_' + index"
                class="eclipse_product_container"
              >
                <button
                  v-if="index > 0"
                  class="close"
                  type="button"
                  style="padding-right: 15px; padding-bottom: 5px"
                  @click="removeProduct(index)"
                >
                  <span aria-hidden="true">x</span>
                </button>

                <div class="form-group col-xs-12">
                  <input
                    autocomplete="off"
                    type="text"
                    name="eclipse_product[]"
                    :value="eclipseProduct.product_name"
                    class="form-control"
                    @click="
                      modal(true, 'eclipseProduct', 'Search Eclipse Product');
                      setIndexModal(index);
                    "
                  />
                </div>
                <div class="form-group col-xs-12">
                  <select
                    class="form-control"
                    name="product_implementation"
                    required
                    @change="handleImplementationSelect($event, index)"
                  >
                    <option value="">-- Select Implementation --</option>
                    <option value="ces">CES</option>
                    <option value="var">VAR</option>
                  </select>
                </div>
                <div class="clearfix"></div>
                <hr />
              </div>
              <div>
                <div class="col-xs-12">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="addEclipseProduct()"
                  >
                    + Add Another Product
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <button id="form_submit" type="submit" class="btn btn-primary">
          <span v-if="loadingSubmit === false">Submit</span>
          <span v-else-if="loadingSubmit === true">Processing...</span>
        </button>
      </div>
    </form>

    <modal v-if="modalId === 'eclipseProduct'" :show-modal="showModal">
      <eclipse-product-search></eclipse-product-search>
    </modal>
  </div>
</template>

<script>
import EclipseProductSearch from "../forms/eclipseProductSearch.vue";
import Modal from "../../../Modal.vue";

export default {
  components: {
    EclipseProductSearch,
    Modal,
  },
  data() {
    return {
      locale_id: 1,
      nexus_type: "saas",
      name: "",
      base_price: "",
      description: "",
    };
  },
  computed: {
    locales() {
      return this.$store.state.dic.locales;
    },
    loadingSubmit() {
      return this.$store.state.subsAddon.loading_submit;
    },
    code() {
      return this.$store.state.subsAddon.code;
    },
    nexusType() {
      return this.$store.state.subsAddon.nexus_type;
    },
    localeId() {
      return this.$store.state.subsAddon.locale_id;
    },
    codeExist() {
      return this.$store.state.subsAddon.code_exist;
    },
    showModal() {
      return this.$store.state.dic.show_modal;
    },
    modalId() {
      return this.$store.state.dic.modal_id;
    },
    eclipseProducts() {
      return this.$store.state.product.eclipse_products;
    },
    groupEclipseProductId() {
      return this.$store.state.product.group_eclipse_product_id;
    },
    groupEclipseProductName() {
      return this.$store.state.product.group_eclipse_product_name;
    },
    groupEclipseProductImplementation() {
      return this.$store.state.product.group_eclipse_product_implementation;
    },
  },
  mounted() {
    this.$store.dispatch("getLocales", null, { root: true });
    this.$store.dispatch("setNexusType", this.nexus_type);
    this.$store.dispatch("setLocale", this.locale_id);
    this.$store.dispatch("setInitialProduct", null, { root: true });
  },
  methods: {
    addSubscriptionBundleForm() {
      this.$store.dispatch("groupEclipseProductData", null, { root: true });
      const formFields = this.prepareDataToSubmit();
      this.$store.dispatch("submitNewSubscriptionAddonForm", formFields);
    },
    prepareDataToSubmit() {
      return {
        code: this.code,
        name: this.name,
        base_price: this.base_price,
        nexus: this.nexusType,
        description: this.description,
        locale_id: this.localeId,
        eclipse_product: this.groupEclipseProductId,
        eclipse_product_name: this.groupEclipseProductName,
        product_implementation: this.groupEclipseProductImplementation,
      };
    },
    handleCode(event) {
      this.$store.dispatch("setCode", event.target.value);
      this.$store.dispatch("checkCode");
    },
    handleNexusSelect(event) {
      this.$store.dispatch("setNexusType", event.target.value);
    },
    handleLocaleSelect(event) {
      this.$store.dispatch("setLocale", event.target.value);
    },
    addEclipseProduct() {
      this.$store.dispatch("addNewEclipseProduct", null, { root: true });
    },
    removeProduct(index) {
      this.$store.dispatch("removeProduct", index, { root: true });
    },
    modal(modalState, modalId, modalTitle) {
      this.$store.dispatch("clearEclipseSearchResults", null, { root: true });
      this.$store.dispatch(
        "setModal",
        { modal_id: modalId, modal_title: modalTitle },
        { root: true }
      );
      this.$store.dispatch("setModalState", modalState, { root: true });
    },
    setIndexModal(index) {
      this.$store.dispatch("setIndexModal", index, { root: true });
    },
    handleImplementationSelect(event, index) {
      this.$store.dispatch(
        "setProdImplementationValue",
        { value: event.target.value, index },
        { root: true }
      );
    },
  },
};
</script>
